export default () => ({
  healthEvents: [],
  summaries: [],
  poolFilters: [],
  currentSummary: {},
  currentSecondaryFilters: {},
  pagination: {
    isFetching: false,
    hasError: false,
    stopLoad: false,
    range: null
  },
  filters: {},
  sortBy: 'dueDate',
  sortOrder: 'asc'
})
